export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/houseAuth/query`,
          data
        });
      },
      /**
       * 获取认证详情
       * @param data
       * @return {*}
       */
      getHouseInfo(data) {
          return http.json({
              url: `/houseAuth/get?id=${data.id}`
          })
      },
      /**
       * 保存奖券
       * @param data
       * @returns {*}
       */
      saveLottery (data){
          return http.json({
              url: '/houseAuth/saveLotteryNum',
              data
          });
      },
      /**
       * 删除房产认证
       * @param data
       * @return {*}
       */
      removeHouseAuth(data) {
          return http.get(
              `/houseAuth/delete?id=${data[0].id}`
          )
      },
      /**
       * 获取用户认证详情
       * @param data
       * @return {*}
       */
      houseAuthList(data){
          return http.json({
              url: `/houseAuth/backgroundList?idCard=${data.idCard}`,
          })
      },
      /**
       * 不分页数据
       * @param data
       * @return {*}
       */
      backList(data){
          return http.json({
              url: `/houseAuth/backList`,
              data
          });
      },
      queryHouseStatus(){
        return http.json({
            url: `/houseAuth/queryHouseStatus`,
        });
    },
   
    submitHouseStatus(data){
        return http.json({
            url: `/houseAuth/submitHouseStatus`,
            data
        });
    },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/houseAuth.js